class LocalDatabase {
    constructor(private _databaseName: string, private _version = 1) {
    }

    private _open(storeName: string, callback: any) {
        let db: any;

        const openRequest = indexedDB.open(this._databaseName, this._version);

        openRequest.onupgradeneeded = function (e: any) {
            db = e.target.result;
            db.createObjectStore(storeName, { keyPath: "id", autoIncrement: true });
        };

        openRequest.onsuccess = () => {
            db = openRequest.result;

            callback(db);
        };
    }

    private _storeAction(storeName: string, callback: any) {
        const storeCallback = (db: any) => {

            const transaction = db.transaction(storeName, "readwrite");

            const store = transaction.objectStore(storeName);

            callback(store);
        }

        this._open(storeName, storeCallback);
    }

    get(storeName: string, callback: any) {
        const readAll = (db: any) => {
            const objectStore = db.transaction(storeName).objectStore(storeName);
            const records: Array<any> = [];

            objectStore.openCursor().onsuccess = function (event: any) {
                const cursor = event.target.result;

                if (cursor) {
                    records.push(cursor.value);
                    cursor.continue();
                } else {
                    records.reverse();
                    callback(records)
                }
            };
        }

        this._open(storeName, readAll);
    }

    clear(storeName: string) {
        const clear = (store: any) => store.clear();

        this._storeAction(storeName, clear);
    }

    add(storeName: string, item: any) {
        const add = (store: any) => {
            try {
                store.add(item);
            } catch (error) {
                console.error(`Error adding to ${storeName}`, item)
            }
        }

        this._storeAction(storeName, add);
    }
}

export default LocalDatabase;